<div class="flex h-full gap-6 overflow-hidden">
  <div class="flex h-full w-1/4 min-w-[460px] flex-col overflow-hidden rounded-3xl bg-neutral-0 px-2 py-4 shadow-lg">
    <div class="flex-shrink-0">
      <md-search></md-search>

      @if (showAiContextSearch() && isAiSearchFeatureEnabled() && (aiSearchResponseMessage() || isAiSearchLoading()) && !loadingDocumentsList()) {
        <div class="mb-4 flex flex-col items-start">
          <span class="text-sm font-bold">{{ "medicalDocuments.label.AIAssistant" | translate }}</span>
          <div class="text-md mb-2 w-full rounded-md border border-dashed border-neutral-200 bg-neutral-50 px-4 py-2 italic">
            @if (isAiSearchLoading()) {
              <div class="flex items-center gap-2">
                <shared-spin-loading [size]="16"></shared-spin-loading>
                <span>{{ "medicalDocuments.label.analyzing" | translate }}</span>
              </div>
            } @else {
              {{ aiSearchResponseMessage() }}
            }
          </div>
        </div>
      }
    </div>

    @if (isAiMedicalDataEnabled()) {
      <div
        sharedInfiniteScroll
        class="h-0 min-h-[calc(100%-56px)] w-full overflow-y-auto px-2"
        [scrollLoading]="loadingDocumentsList()"
        [hasNextPage]="documentsPageConfig()?.hasNextPage"
        (fetchNextPage)="fetchNextPage()"
      >
        @if (!loadingDocumentsList()) {
          @if (displayDocuments().length > 0 || uploadingDocuments().length > 0) {
            <md-ai-list></md-ai-list>
          } @else {
            <p class="py-5 text-center text-sm">{{ "medicalDocuments.description.empty" | translate }}</p>
          }
        } @else if (documentsPageConfig()?.page > 0 && loadingDocumentsList()) {
          <div class="my-0.5 flex justify-center">
            <shared-spin-loading [size]="24"></shared-spin-loading>
          </div>
        } @else {
          <div class="flex justify-center">
            <shared-loader></shared-loader>
          </div>
        }
      </div>
    } @else {
      <div
        sharedInfiniteScroll
        class="h-0 min-h-[calc(100%-56px)] w-full overflow-y-auto px-2"
        [scrollLoading]="loadingDocumentsList()"
        [hasNextPage]="documentsPageConfig()?.hasNextPage || false"
        (fetchNextPage)="fetchNextPage()"
      >
        @if (!loadingDocumentsList()) {
          @if (documents().length > 0) {
            <md-list></md-list>
          } @else {
            <p class="py-5 text-center text-sm">{{ "medicalDocuments.description.empty" | translate }}</p>
          }
        } @else if (documentsPageConfig()?.page > 0 && loadingDocumentsList()) {
          <div class="my-0.5 flex justify-center">
            <shared-spin-loading [size]="24"></shared-spin-loading>
          </div>
        } @else {
          <div class="flex justify-center">
            <shared-loader></shared-loader>
          </div>
        }
      </div>
    }
  </div>

  @if (detailsState() === "opened" || (detailsState() === "inEdit" && canEditDocuments())) {
    <div class="h-full w-1/4 min-w-[460px] overflow-hidden">
      @if (detailsState() === "inEdit" && canEditDocuments()) {
        <md-document-details-form
          [userAppointments]="userAppointments()"
          [currentAiDocument]="currentAiDocument()"
          (detailsClosed)="closeDetails()"
          (formSubmitted)="onFormSubmitted($event)"
          (formCancelled)="onFormCancelled($event)"
        ></md-document-details-form>
      } @else {
        <md-document-details
          [userAppointments]="userAppointments()"
          [currentAiDocument]="currentAiDocument()"
          [canEdit]="canEditDocuments()"
          (detailsClosed)="closeDetails()"
          (editModeOpened)="openEditMode()"
        ></md-document-details>
      }
    </div>
  }

  <div class="flex h-full w-full flex-col items-center justify-center gap-4 overflow-hidden">
    <md-document-preview></md-document-preview>
  </div>
</div>
